// API client for the Promotion Performance Tracker.
const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
const BASE = `${API_URL}/seller-intelligence/promotions`;

const authHeaders = (token) => ({
  Authorization: `Bearer ${token}`,
  'Content-Type': 'application/json',
});

export class ReportUnavailableError extends Error {
  constructor(message) { super(message); this.reportUnavailable = true; }
}

export class NotConnectedError extends Error {
  constructor(message) { super(message); this.notConnected = true; }
}

const call = async (url, options = {}) => {
  const res = await fetch(url, options);
  const data = await res.json().catch(() => ({}));
  if (res.status === 409 && data.error === 'report_unavailable') {
    throw new ReportUnavailableError(data.message);
  }
  if (res.status === 400 && data.error === 'amazon_not_connected') {
    throw new NotConnectedError(data.message);
  }
  if (!res.ok) throw new Error(data.message || `Request failed (${res.status})`);
  return data;
};

// SF4 — whether each promotion made money, after every cost.
export const getReturns = (token) =>
  call(`${BASE}/returns`, { headers: authHeaders(token) });

// SF3 — the same episodes cut by discount depth.
export const getDepth = (token) =>
  call(`${BASE}/depth`, { headers: authHeaders(token) });

// SF5 — which promotion types have paid.
export const getTypes = (token) =>
  call(`${BASE}/types`, { headers: authHeaders(token) });

// SF6 — demand that jumped with no promotion behind it.
export const getSpikes = (token) =>
  call(`${BASE}/spikes`, { headers: authHeaders(token) });

// SF1 — what is promoting right now, read live from the Promotions API rather
// than from a report. `refresh` bypasses the backend's short cache, for a seller
// who has just changed something in Seller Central.
export const getLivePromotions = (token, { refresh = false } = {}) =>
  call(`${BASE}/live${refresh ? '?refresh=1' : ''}`, { headers: authHeaders(token) });
